import React, { useState } from "react";
import { Modal, Button, Icon } from "semantic-ui-react";
import { useCookies } from "react-cookie";

import FleetFilter from "./FleetFilter";

const PowerplantsFilter = () => {
  const [cookies, setCookie, removeCookie] = useCookies(["HMI_FILTER"]);
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState(cookies.HMI_FILTER || {});

  const handleClose = () => {
    setFilter(cookies.HMI_FILTER || {});
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClear = () => {
    setFilter({});
  };

  const handleApply = () => {
    if (Object.keys(filter).length === 0) {
      removeCookie("HMI_FILTER", { path: "/" });
      setOpen(false);
      return;
    }
    setCookie("HMI_FILTER", filter, {
      path: "/",
      secure: true,
      maxAge: 31536000,
    });
    setOpen(false);
  };

  return (
    <Modal
      centered={true}
      trigger={
        <Button
          color={cookies.HMI_FILTER ? "blue" : undefined}
          onClick={handleOpen}
          style={styles.filterButton}
        >
          <Icon style={styles.filterIcon} name="filter" size="large" />
        </Button>
      }
      size="large"
      open={open}
      onClose={handleClose}
    >
      <Modal.Header content="Filter PowerPlants" />
      <Modal.Content>
        <FleetFilter
          all
          filter={filter}
          setFilter={setFilter}
          showGroup={false}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          floated="left"
          color="red"
          content="Clear Filter"
          onClick={handleClear}
        />
        <Button color="green" content="Apply" onClick={handleApply} />
        <Button content="Cancel" onClick={handleClose} />
      </Modal.Actions>
    </Modal>
  );
};

const styles = {
  filterButton: {
    marginLeft: "10px",
  },
  filterIcon: {
    paddingLeft: "7px",
  },
};

export default PowerplantsFilter;
